define('modules/includes_editor/views/main',['require','exports','module','backbone','base/layout','common/views/modal_layout','./list','./editor','base/vent','ldsh!../templates/layout'],function (require, exports, module) {
  'use strict';
  var Backbone = require('backbone'),
    Layout = require('base/layout'),
    ModalLayout = require('common/views/modal_layout'),
    ListView = require('./list'),
    EditorView = require('./editor'),
    Vent = require('base/vent');

  module.exports = ModalLayout.extend({
    template: require('ldsh!../templates/layout'),
    //className: "modal fade",
    regions: {
      list: '.js-includelist',
      editor: '.js-includeeditor',
    },

    events: {
      'click .js-save': 'saveIncludes',
      'click .js-add': 'addItem',
      'click .js-remove': 'removeItem',
      'click .js-help': 'showHelp',
      'shown.bs.modal': 'onModalShown',
    },

    initialize: function (options) {
      this.viewState = new Backbone.Model();
      this.vent = new Vent();
      this.editorMode = options.editorMode || 'css';

      if (!options.collection) {
        throw new Error('Collection missing for include editor');
      }
      this.collection = options.collection;
      //create layout views
      this.regions.list.show(
        new ListView({
          collection: this.collection,
          state: this.viewState,
          vent: this.vent,
          editableItemName: options.editableItemName,
        })
      );
      //listen for selectedItem change from list view
      this.listenTo(this.viewState, 'change:selectedItem', this.onSelectedItemChange);
      this.listenTo(this.viewState, 'change:canSave', this.toggleSaveButton);
      this.listenTo(this.collection, 'sync', this._selectFirstItem);
      this.listenTo(
        this.vent,
        'editor:content:change',
        _.bind(this.viewState.set, this.viewState, 'canSave', true)
      );
      if (!this.collection.length) this.collection.addItem();
    },

    saveIncludes: function () {
      if (!this.viewState.get('canSave')) return;
      //save current selected include
      this.vent.trigger('save');
      var includes = this.collection.toJSON();
      this.trigger('modal:save', includes);
    },

    addItem: function () {
      var newItem = this.collection.addItem();
      this.viewState.set('selectedItem', newItem);
    },

    removeItem: function () {
      if (!this.viewState.has('selectedItem')) {
        return;
      }

      this.collection.remove(this.viewState.get('selectedItem'));
      this.viewState.unset('selectedItem');
      this._selectFirstItem();
      this.viewState.set('canSave', true);
    },

    showHelp: function (e) {
      this.collection.showHelp(e);
    },

    onSelectedItemChange: function (model, item) {
      //edit selected item
      if (!item) {
        this.regions.editor.close();
        return;
      }
      this.viewState.set('canSave', false);
      this.regions.editor.show(
        new EditorView({
          state: this.viewState,
          vent: this.vent,
          model: item,
          editorMode: this.editorMode,
        })
      );
    },

    toggleSaveButton: function () {
      this.$('.js-save').toggleClass('is-disabled', !this.viewState.get('canSave'));
    },

    onModalShown: function () {
      this.vent.trigger('modal:shown');
      this._selectFirstItem();
    },

    _selectFirstItem: function () {
      if (this.collection.length) {
        this.viewState.set('selectedItem', this.collection.first());
      }
    },

    onRender: function () {
      this.toggleSaveButton();
      this.$el.i18n();
    },
  });
});

